export default __webpack_public_path__ + "b9da477b29e404fbb69d547dea754bc8.svg";